// extracted by extract-css-chunks-webpack-plugin
module.exports = {"quickSearchInput":"quickSearchInput-2-m87"};